<template>
    <div
        class="modal fade"
        id="editQuoteModal"
        tabindex="-1"
        aria-labelledby="editQuoteModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="editQuoteModalLabel">
                        Editing Quote {{ quoteId }}
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        :disabled="isSubmitting"
                    ></button>
                </div>
                <div class="modal-body">
                    <div class="row g-3">
                        <div class="col-12 col-md-6">
                            <label class="form-label"> <strong>Quote Type</strong></label>
                            <input
                                id="current_quote_type"
                                class="form-control"
                                maxlength="10"
                                :value="currentQuoteType"
                                :disabled="true"
                            />
                        </div>
                        <div class="col-12 col-md-6">
                            <label class="form-label"><strong>New Quote Type</strong></label>
                            <select
                                id="edit_quote_type_select"
                                v-model="selectedQuoteType"
                                class="form-select"
                                :disabled="isSubmitting"
                            >   
                                <option
                                    v-for="(quoteType, index) in quoteTypeItems"
                                    :value="quoteType"
                                    :key="index"
                                >
                                    {{ quoteType }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="d-flex justify-content-end w-100 gap-2">
                        <button class="btn btn-danger" @click="doClose()" :disabled="isSubmitting">Cancel</button>
                        <button class="btn btn-success" @click="doSubmit()" :disabled="isSubmitting">
                            <span v-if="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            <span v-if="!isSubmitting">Submit</span>
                            <span v-else>Submitting...</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Modal } from 'bootstrap'
    import { useDropdownsStore } from '@/stores/dropdownsStore'
    import { mapStores } from 'pinia'
    import { useUserStore } from '@/stores/userStore'
    import { useQuoteListStore } from '@/stores/quoteListStore'
    import searchAction from '@/services/searchAction.service'

    export default {
        name: 'ModalEditQuote',
        watch: {
            currentQuoteType(newVal) {
                this.selectedQuoteType = newVal
            }
        },
        computed: {
            ...mapStores(useDropdownsStore, useUserStore, useQuoteListStore),
            isStaff() {
                return this.userStore.isStaff
            },
            quoteTypeItems: {
                get() {
                    return this.dropdownsStore.quote_types
                },
            },
        },
        data() {
            return {
                selectedQuoteType: '',
                isSubmitting: false,
            }
        },
        props: {
            quoteId: {
                type: Number,
                required: true,
            },
            currentQuoteType: {
                type: String,
                required: true,
            },
        },
        methods: {
            doClose() {
                const modalElement = document.getElementById('editQuoteModal')
                if (modalElement) {
                    const modal = Modal.getInstance(modalElement) || new Modal(modalElement)
                    modal.hide()
                }
            },
            doSubmit() {
                if (this.isSubmitting) return;
                this.isSubmitting = true;
                const payload = {
                    id: this.quoteId,
                    quote_type: this.selectedQuoteType
                };
                searchAction.patchSearchActionQuoteTypes({
                    id: this.quoteId,
                    payload
                })
                    .then((response) => {
                        const data = response.data
                        this.quoteListStore.updateQuoteTypeBySearchActionId(data?.search_action_id, data?.quote_type)
                        this.doClose()
                    })
                    .catch((error) => {
                        console.error('Error updating quote type:', error)
                    })
                    .finally(() => {
                        this.isSubmitting = false
                    });
            },
        },
    }
</script>
